import { useCallback } from "react"
import { graphql, useMutation, UseMutationConfig } from "react-relay"
import { useChDeletePsychologicalPsychoTherapyMutation as useChDeletePsychologicalPsychoTherapyMutationType } from "@/modules/patients/detail/therapy-prescription/ch/services/__generated__/useChDeletePsychologicalPsychoTherapyMutation.graphql"

const mutation = graphql`
  mutation useChDeletePsychologicalPsychoTherapyMutation($input: Ch_deletePsychotherapyPrescriptionInput!) {
    ch_deletePsychotherapyPrescription(input: $input) {
      ch_PsychotherapyPrescription {
        id @deleteRecord
      }
    }
  }
`

const useChDeletePsychologicalPsychoTherapyMutation = () => {
  const [commit, isFlight] = useMutation<useChDeletePsychologicalPsychoTherapyMutationType>(mutation)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useChDeletePsychologicalPsychoTherapyMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChDeletePsychologicalPsychoTherapyMutation }
